export default __webpack_public_path__ + "static/media/no-data-icon.e7ba629a.png";